import { Navigate } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { useAuthorization } from "@hooks";
import { IRootieComponent } from '@components-common/types';
import { useIsAuthenticated } from '@azure/msal-react';

export const AuthorizedTemplate = ({ children, roles }: any) => {
  const authorizationService = useAuthorization();
  return authorizationService.hasPermission(roles) ? children : <Navigate to="/errors/forbidden" />;
}

export const ProtectedRoute = ({ children, ...rest }: any) => {
  const isAuthenticated = useIsAuthenticated();
  console.log('IM0AUYTHENTICATED', isAuthenticated)
  return (
    <>
    {/* {children} */}
      <AuthenticatedTemplate>
        <AuthorizedTemplate {...rest}>{children}</AuthorizedTemplate>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Navigate to="/auth/login" />
      </UnauthenticatedTemplate>
    </>
  );
};

export const protectedRoute:IRootieComponent = {
  cat: "route",
  type: "protected",
  Component: ProtectedRoute,
  props: {}
}

